export default __webpack_public_path__ + "20131ba62a7b37ec5571a118974badba.png";